import { call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  addStrapiData,
  deleteFileFromStrapi,
  deleteStrapiData,
  extractStrapiData,
  fetch5SInconsistencyFilesOne,
  uploadFileToStrapi,
} from '../../api/api';
import {
  fetchInconsistencyFilesSuccess,
  fetchInconsistencyFilesFailure,
  uploadInconsistencyFileSuccess,
  uploadInconsistencyFileFailure,
  deleteInconsistencyFileSuccess,
  deleteInconsistencyFileFailure,
} from './actions';
import {
  DeleteFileRequestAction,
  FetchFilesRequestAction,
  InconsistencyFile,
  UploadFileRequestAction,
} from '../../types/inconsistency5SFiles';

const MODEL_NAME = 'mt-5-s-inconsistency-files';

const mapStrapiToFile = (row: any): InconsistencyFile => ({
  recordDocumentId: row.documentId,
  fileId: row.File?.id,
  name: row.File?.name || row.Title || 'file',
  sizeBytes: row.File?.size ? row.File.size * 1024 : 0,
  url: row.File?.url,
});

export function* fetchInconsistencyFilesSaga(action: FetchFilesRequestAction) {
  const { inconsistencyId, inconsistencyDocumentId } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(fetch5SInconsistencyFilesOne, inconsistencyDocumentId);
    const items = extractStrapiData(response) || [];
    yield put(fetchInconsistencyFilesSuccess(inconsistencyId, items.map(mapStrapiToFile)));
  } catch (error) {
    const message = (error as any)?.message || 'Ошибка загрузки файлов';
    yield put(fetchInconsistencyFilesFailure(inconsistencyId, message));
  }
}

export function* uploadInconsistencyFileSaga(action: UploadFileRequestAction) {
  const { inconsistencyId, file, tempId } = action.payload;
  try {
    const uploadResp: AxiosResponse<any> = yield call(uploadFileToStrapi, file);
    const uploaded = uploadResp.data?.[0];
    if (!uploaded) throw new Error('upload failed');

    const recordResp: AxiosResponse<any> = yield call(addStrapiData, MODEL_NAME, {
      File: uploaded.id,
      Inconsistency: inconsistencyId,
      Title: uploaded.name,
    });
    const record = extractStrapiData(recordResp);

    yield put(
      uploadInconsistencyFileSuccess(inconsistencyId, tempId, {
        recordDocumentId: record?.documentId,
        fileId: uploaded.id,
        name: uploaded.name,
        sizeBytes: file.size,
        url: uploaded.url,
      }),
    );
  } catch (error) {
    const message = (error as any)?.message || 'Ошибка загрузки файла';
    yield put(uploadInconsistencyFileFailure(inconsistencyId, tempId, message));
  }
}

export function* deleteInconsistencyFileSaga(action: DeleteFileRequestAction) {
  const { inconsistencyId, recordDocumentId, fileId } = action.payload;
  try {
    yield call(deleteStrapiData, MODEL_NAME, recordDocumentId);
    if (fileId) {
      try {
        yield call(deleteFileFromStrapi, fileId);
      } catch (err) {
        console.error('Не удалось удалить файл из хранилища', err);
      }
    }
    yield put(deleteInconsistencyFileSuccess(inconsistencyId, recordDocumentId));
  } catch (error) {
    const message = (error as any)?.message || 'Ошибка удаления файла';
    yield put(deleteInconsistencyFileFailure(inconsistencyId, recordDocumentId, message));
  }
}
